<div
  class="header-container"
  [ngStyle]="{ 'background-image': imageUrl && 'url(\'' + imageUrl + '\')' }"
>
  <ng-content></ng-content>
</div>
